import React, { PureComponent } from 'react'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { connect } from 'react-redux'
import { BarLoader } from 'react-spinners'
import { APP_URL, PAGE_PREFIX } from '../utils/config.js'
import { Link } from 'react-router-dom'
import {
  setCanProceedToNextStep,
  setIndividualRoundedBack,
  setIndividualRoundedSeat,
  setSelectedSet,
} from '../actions/generalActions.js'
import { displayToast, sendGtag } from '../utils/utils.js'
import _ from 'lodash'
import { setCushionDimensions, setIsHalfInchRemoved } from '../actions/cushionActions.js'
import SwiperComponent from './Swiper/index.js'

class CushionSetSelector extends PureComponent {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { dispatch, general } = this.props
    const { set, removeItem } = general

    scrollTo('designer-body', 0)

    if (set === null) {
      dispatch(setCanProceedToNextStep(false))
    } else {
      dispatch(setCanProceedToNextStep(true))
    }
    if (removeItem) {
      dispatch({ type: 'FETCH_ATTRIBUTE_TERMS_BY_ID_SUCCESS' })
    }
  }

  componentDidUpdate(prevProps) {
    const { cushion, params, dispatch, history } = this.props
    const { cushionSets } = cushion

    if (prevProps.cushion.cushionSets !== cushionSets) {
      if (params.type.id === '166') {
        if (cushionSets) {
          let oneSet = cushionSets?.find((set) => set.id.toString() === '782')
          dispatch(setSelectedSet(oneSet))
          dispatch(setCanProceedToNextStep(true))
        }
      }
      if (params.type.id === '11786') {
        if (cushionSets) {
          let oneSet = cushionSets?.find((set) => set.id.toString() === '860')
          dispatch(setSelectedSet(oneSet))
          dispatch(setCanProceedToNextStep(true))
        }
      }
      if (cushionSets && params.set?.id !== 'set') {
        let selectedSet = cushionSets.find((set) => set.id.toString() === params.set?.id)
        if (selectedSet) {
          dispatch(setCanProceedToNextStep(true))
        } else {
          history.push(`/cd/${params.category}/type`)
          displayToast(
            'The URL you were trying to access is broken. Please reselect your options',
            'error',
          )
        }
      }
    }
  }

  _getCushionSet = () => {
    const { params, dispatch, cushion, general } = this.props
    const { cushionSets } = cushion
    if (
      cushionSets &&
      params.set?.id !== 'set' &&
      cushionSets.find((set) => set.id.toString() === params.set) !== undefined
    ) {
      const selectedSet = cushionSets.find((set) => set.id.toString() === params.set?.id)

      if (general?.set?.id !== selectedSet?.id) {
        sendGtag('add_set', `${general?.type?.name}_${selectedSet?.name}`)
      }

      dispatch(
        setSelectedSet(
          selectedSet,
          true,
        ),
      )
    }
  }

  _selectCushionSet = (set) => () => {
    const { cushion, dispatch, general } = this.props
    const { initialCushionDimensions, isHalfInchRemoved } = cushion

    if (general?.set?.id !== set?.id) {
      sendGtag('add_set', `${general?.type?.name}_${set?.name}`)
    }

    const splitSetSlug = set.slug.split('-')
    const shouldRemoveHalfInch = parseInt(splitSetSlug[0]) > 1 || parseInt(splitSetSlug[2]) > 1

    if (!isHalfInchRemoved && shouldRemoveHalfInch) {
      const cushionDimensionsCopy = _.cloneDeep(initialCushionDimensions)
      cushionDimensionsCopy.width = [...initialCushionDimensions.width].filter((dimension) =>
        Number.isInteger(parseFloat(dimension)),
      )
      dispatch(setCushionDimensions(cushionDimensionsCopy))
      dispatch(setIsHalfInchRemoved(true))
    } else if (isHalfInchRemoved && !shouldRemoveHalfInch) {
      dispatch(setCushionDimensions(initialCushionDimensions))
      dispatch(setIsHalfInchRemoved(false))
    }

    dispatch(setSelectedSet(set, true))
    dispatch(setIndividualRoundedBack(false))
    dispatch(setIndividualRoundedSeat(false))
  }

  _getTypeImage = (param) => {
    try {
      return require(`../../assets/set/${param}.webp`).default
    } catch (error) {
      console.log('Failed to laod image:', error) //eslint-disable-line
      return ''
    }
  }

  _renderCushionSets = () => {
    const { location, general, cushion } = this.props
    const { set, type } = general
    const { cushionSets } = cushion
    let splitPathName = location.pathname.split('/')

    if (cushionSets === null) {
      return <BarLoader color={'#93C44E'} css={{ position: 'absolute' }} />
    }
    return cushionSets.map((cushion, index) => {
      splitPathName[splitPathName.length - 1] = cushion.id
      const replacedPathName = splitPathName.join('/')
      return (
        <div
          id={`cushion-set-${index}`}
          key={cushion.id}
          onClick={this._selectCushionSet(cushion)}
          className={`cushion-type-selector-card ${set?.id === cushion.id ? 'active' : ''}`}
        >
          <div className={'cushion-type-selector-card-checkbox'}>
            {set?.id === cushion.id && (
              <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
            )}
          </div>
          <img src={this._getTypeImage(`${type.slug}-${cushion.slug}`)} />
          <Link id={`cushion-set-${index}`} to={`${PAGE_PREFIX}${replacedPathName}/dimensions`}>
            <div className="card-title">{cushion.name}</div>
          </Link>
        </div>
      )
    })
  }

  render() {
    const { cushion, general } = this.props
    const { fetchingAttributeTermsById } = cushion
    const { type } = general

    const slides = Array.from(this._renderCushionSets())
    const initialSlideIndex = 0

    return fetchingAttributeTermsById ? (
      <BarLoader color={'#93C44E'} css={{ position: 'absolute', left: '50%', right: '50%' }} />
    ) : (
      <div
        className={`cushion-type-selector set-selector ${type?.slug === 'loveseat' ? 'loveseat' : ''}`}
      >
        <SwiperComponent
          slides={slides}
          slidesPerView={1}
          slidesPerGroup={1}
          initialSlideIndex={initialSlideIndex}
          hasArrows={false}
          slideEventName="scroll_button_set"
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionSetSelector))
